import { useEffect, useState } from "react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MovieCard from "../components/MovieCard";
import { Heart } from "lucide-react";

export default function MyList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/watchlist").then((r) => {
      setItems(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="bg-[#050505] min-h-screen text-white" data-testid="my-list-page">
      <Navbar />
      <div className="pt-32 px-4 sm:px-12 max-w-[1600px] mx-auto pb-20">
        <h1 className="text-5xl sm:text-6xl font-black tracking-tighter mb-2" style={{ fontFamily: "Outfit" }}>My List</h1>
        <p className="text-[#999] mb-8">Everything you've saved for later.</p>
        {loading ? (
          <div className="text-[#777]">Loading...</div>
        ) : items.length === 0 ? (
          <div className="text-center py-24 text-[#888]">
            <Heart className="mx-auto mb-3" size={36} />
            Your list is empty. Browse and add titles to keep them here.
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4">
            {items.map((item) => (
              <MovieCard key={item.id} item={item} type={item.totalSeasons ? "series" : "movie"} />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
